import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getMailingList(action) {
    try {
        const mailingLists = yield call(() =>
            configurationsAPI.getMailingLists(action.payload.subsidiary)
        );

        yield put({
            type: ConfigurationsActionTypes.GET_MAILING_LISTS_SUCCESS,
            payload: mailingLists.data
        });

    } catch (e) {
        API.handleError(e.response, "Error getting Mailing Lists.");

        yield put({
            type: ConfigurationsActionTypes.GET_MAILING_LISTS_FAIL,
            message: e.message
        });
    }
}

export function* getMailingListWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_MAILING_LISTS,
        getMailingList
    );
}
